/** Landing-page display price formatting (currency-aware).
 * Uses Intl so INR/USD/EUR/etc. need no architecture change.
 */

export function formatLandingPrice(amount: number, currency: string): string {
  const code = (currency || 'INR').trim().toUpperCase() || 'INR'
  try {
    const isInr = code === 'INR'
    return new Intl.NumberFormat(isInr ? 'en-IN' : undefined, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: isInr ? 0 : 2,
      maximumFractionDigits: isInr ? 0 : 2,
    }).format(amount)
  } catch {
    return `${code} ${amount}`
  }
}

/** GST note is India-only on the landing display. */
export function showLandingGstNote(currency: string): boolean {
  return (currency || '').trim().toUpperCase() === 'INR'
}
